import { ICreatePesquisaSatisfacaoClienteUseCase } from "../../../presentation/useCases/create/create_pesquisa_satisfacao_cliente_use_case";
import { IEntregaObrasRepository } from "../../repositories/entrega_obras_repositories";

/**
 * CreatePesquisaSatisfacaoClienteUseCase
 */

export class CreatePesquisaSatisfacaoClienteUseCase implements ICreatePesquisaSatisfacaoClienteUseCase {
  constructor(private readonly repository: IEntregaObrasRepository) { }

  async createPesquisaSatisfacaoCliente(
    idSatisfacaoCliente: number,
    idsPesquisaSatisfacao: number[],
  ): Promise<void> {
    await this.repository.createPesquisaSatisfacaoCliente(
      idSatisfacaoCliente,
      idsPesquisaSatisfacao,
    );
  }
}
